module.exports = __webpack_public_path__ + "static/media/profile-user-icon.f93a558a.svg";